import axios from 'axios';

const BASE_URL = '/app/funnel';

export const flowEmailReporting = async (params) => {
    return axios.post(`${BASE_URL}/flow/reporting-cards`, params);
};
